import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-manage-workspace-permission-help',
  template: `
    <div>
      <span><b>{{'USER_PERMISSIONS.MANAGE_WORKSPACE.INTRODUCTION' | translate}}:</b></span>
      <ul class="m-0">
        <li>{{'USER_PERMISSIONS.MANAGE_WORKSPACE.CAN_CREATE_FOLDERS' | translate}}</li>
        <li>{{'USER_PERMISSIONS.MANAGE_WORKSPACE.CAN_UPLOAD_ATTACHMENTS' | translate}}</li>
        <li>{{'USER_PERMISSIONS.MANAGE_WORKSPACE.CAN_DELETE_EMPTY_FOLDERS' | translate}}</li>
        <li>{{'USER_PERMISSIONS.MANAGE_WORKSPACE.CAN_MOVE_RENAME_FOLDERS' | translate}}</li>
      </ul>
    </div>
  `
})
export class ManageWorkspacePermissionHelpComponent {
  constructor(public translate: TranslateService) {
  }
}
